<div class="app-container !p-0">

  <div class="app-page-content grow overflow-auto">

    <app-data-table
      [enableSearch]="true"
      [state]="applicationsState"
      [columnDefs]="columnDefs"
      (onActionPerformed)="onActionClicked($event)"
      (tableStateChanged)="getApplications($event)">
    </app-data-table>

  </div>

</div>
